import React from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "@lib/types/Context";
import { SharedPaymentProviderDetail } from "@app/shared";

const PaymentProviderManagerDetail: React.FC = () => {
  const { providerId } = useParams();

  // Check if user has permission to view wallet pool
  // if (!permissions.canViewWalletPool) {
  //   return <NoPermission />;
  // }

  return (
    <SharedPaymentProviderDetail
      context={AppContext.PAYMENT_PROVIDER}
      providerId={providerId}
    />
  );
};

export default PaymentProviderManagerDetail;
